import { z } from 'zod';
/**
 * Plantillas de marketing: textos que se reutilizan.
 *
 * ☠️ El cuerpo es TEXTO PLANO y habla la gramática de las CAMPAÑAS —`{{nombre}}`
 * y `{{email}}`, un solo nivel—, no la de los documentos (`{{cliente.nombre}}`).
 * Una plantilla escrita con la gramática equivocada le llega al cliente con la
 * marca literal dentro del correo, porque el motor de campañas no la conoce.
 */
export const MARKETING_TEMPLATE_CHANNELS = ['CORREO', 'WHATSAPP'];
/** Lo que de verdad cabe en un WhatsApp sin que se lea como un panfleto. */
export const WHATSAPP_LARGO_RECOMENDADO = 700;
export const MarketingTemplateDtoSchema = z.object({
    id: z.string(),
    name: z.string(),
    channel: z.enum(MARKETING_TEMPLATE_CHANNELS),
    subject: z.string().nullable(),
    bodyText: z.string(),
    createdByName: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const MarketingTemplateListResponseSchema = z.object({
    items: z.array(MarketingTemplateDtoSchema),
});
export const CreateMarketingTemplateSchema = z
    .object({
    name: z.string().trim().min(1, 'La plantilla necesita un nombre').max(120),
    channel: z.enum(MARKETING_TEMPLATE_CHANNELS).default('CORREO'),
    subject: z.string().trim().max(200).nullable().optional(),
    bodyText: z.string().trim().min(1, 'Escribe el mensaje').max(20000),
})
    .refine((d) => d.channel !== 'CORREO' || !!d.subject?.trim(), {
    message: 'Un correo necesita asunto',
    path: ['subject'],
});
/**
 * Al editar se admite cambiar solo una parte. El asunto obligatorio del correo
 * NO se puede comprobar aquí —no se sabe el canal de lo que no se manda—, así
 * que esa regla la vuelve a aplicar la ruta sobre la fila ya fusionada.
 */
export const UpdateMarketingTemplateSchema = z.object({
    name: z.string().trim().min(1).max(120).optional(),
    channel: z.enum(MARKETING_TEMPLATE_CHANNELS).optional(),
    subject: z.string().trim().max(200).nullable().optional(),
    bodyText: z.string().trim().min(1).max(20000).optional(),
});
/**
 * Enviarse a uno mismo la plantilla para verla como la va a ver el cliente.
 *
 * Es lo más barato que existe para no mandar una errata a ciento cincuenta
 * personas. Va SIEMPRE a la dirección de quien lo pide —no se acepta un
 * destinatario— para que esto no pueda convertirse en una forma de mandar
 * correo a quien sea desde la cuenta de la empresa.
 */
export const TestSendMarketingTemplateResponseSchema = z.object({
    enviadoA: z.string(),
});
//# sourceMappingURL=marketing-templates.js.map